import TableChartOptions from "csi/middleware/customView/options/TableChartOptions";
import TablePrintOptions from "csi/middleware/customView/options/TablePrintOptions";
import TableViewOptions from "csi/middleware/customView/options/TableViewOptions";
import { FlexColumn, FlexRowCenter } from "designSystem/index";
import React, { FunctionComponent } from "react";
import BOMViewOptions from "./BOMViewOptions";

const BOMOptionsTab: FunctionComponent = function BOMOptionsTab() {
	return (
		<FlexRowCenter data-csi-automation="BOMOptionsTab">
			<FlexColumn width="100%">
				<BOMViewOptions />
				<TableViewOptions />
				<TableChartOptions />
				<TablePrintOptions />
			</FlexColumn>
		</FlexRowCenter>
	);
};

export = BOMOptionsTab